import { CourseTypes } from 'config';
import { CommonState, ListParams, Pagination } from './common';
import { CourseDirection } from './directions';
import { ImageFields, Images, PhotoTypes } from './photo';
import { IWorkout } from './workout';

export const enum CourseWorkoutType {
  WORKOUT = 'workout',
  WEEKEND = 'weekend',
  TUTORIAL = 'tutorial',
  // TRAILER = 'trailer', // Пока не используем
}

export type Pivot = {
  course_group_id?: number;
  course_id?: number;
  sort?: number;
};

export type Goals = {
  created_at: string;
  id: number;
  pivot: { course_id: number; course_goal_id: number };
  title: string;
  updated_at: string;
};

export interface CourseImages extends Images {
  [ImageFields.COVER]: string | null;
  [ImageFields.CARD_COVER_M_RECTANGLE]: string | null;
  [ImageFields.CARD_COVER_L_RECTANGLE]: string | null;
  [ImageFields.CARD_COVER_DESKTOP]: string | null;
}

export type Course = {
  id: number;
  name: string;
  levels: ILevel[];
  inventory: string;
  is_public: boolean;
  active: boolean;
  course_type: CourseTypes;
  trainer_id: number | null;
  workouts: IWorkout[];
  groups: number[];
  short_description: string | null;
  images: CourseImages;
  new: boolean;
  hit: boolean;
  main: string | null;
  whom: string | null;
  advice: string | null;
  directions: CourseDirection[];
  fixed: boolean;
  fixed_main: boolean;
  //duration используется в тренировках
  duration?: number | null;
};

export type CourseQuery = Omit<Course, 'id' | 'levels' | 'directions'> & {
  levels: number[];
  directions: number[];
};

export enum CourseFields {
  COURSE = 'course',
  WORKOUT = 'workout',
  COMPLEX = 'complex',
  BROADCAST = 'broadcast',
  /** @deprecated Старая структура марафонов, будет заменена */
  MARATHON = 'marathon',
  CHALLENGE = 'challenge',
  TUTORIAL = 'tutorial',
}

export const CourseTypeNames = {
  [CourseTypes.COURSE]: 'Курс',
  [CourseTypes.WORKOUT]: 'Тренировка',
  [CourseTypes.COMPLEX]: 'Комплекс',
  [CourseTypes.BROADCAST]: 'Эфир',
  /** @deprecated Старая структура марафонов, будет заменена */
  [CourseTypes.MARATHON]: 'Марафон',
  [CourseTypes.CHALLENGE]: 'Челлендж',
  [CourseTypes.TUTORIAL]: 'Туториал',
};

export const CourseTypeFields = {
  [CourseTypes.COURSE]: CourseFields.COURSE,
  [CourseTypes.WORKOUT]: CourseFields.WORKOUT,
  [CourseTypes.COMPLEX]: CourseFields.COMPLEX,
  [CourseTypes.BROADCAST]: CourseFields.BROADCAST,
  /** @deprecated Старая структура марафонов, будет заменена */
  [CourseTypes.MARATHON]: CourseFields.MARATHON,
  [CourseTypes.CHALLENGE]: CourseFields.CHALLENGE,
  [CourseTypes.TUTORIAL]: CourseFields.TUTORIAL,
};

export const COURSE_PHOTO_CATEGORY: Record<CourseTypes, PhotoTypes> = {
  [CourseTypes.COURSE]: PhotoTypes.COURSE,
  [CourseTypes.WORKOUT]: PhotoTypes.WORKOUT,
  [CourseTypes.COMPLEX]: PhotoTypes.COMPLEX,
  [CourseTypes.BROADCAST]: PhotoTypes.BROADCAST,
  /** @deprecated Старая структура марафонов, будет заменена */
  [CourseTypes.MARATHON]: PhotoTypes.MARATHON,
  [CourseTypes.CHALLENGE]: PhotoTypes.CHALLENGE,
  [CourseTypes.TUTORIAL]: PhotoTypes.TUTORIAL,
};

export type CourseList = {
  data?: Course[];
  meta?: Pagination;
};

export type CourseListParams = ListParams & { course_type?: number; name?: string };

export type CourseListLiteParams = ListParams & {
  course_type?: number;
  group_id?: number;
  level_id?: number;
  direction_id?: number;
  name?: string;
};

export type CourseListLiteFilters = Omit<CourseListLiteParams, keyof ListParams>;

export type CourseListLiteFilterKey = keyof CourseListLiteFilters;

export type CourseInList = {
  id: number;
  name: string;
  course_type: CourseTypes;
  new: boolean;
  hit: boolean;
  is_public: boolean;
  active: boolean;
  fixed: boolean;
  fixed_main: boolean;
};

export type CourseRecommendation = {
  id: number;
  name: string;
  course_type: CourseTypes;
  sort: number;
};

export type CourseRecommendationQuery = {
  id: number;
  course_type: CourseTypes;
  sort: number;
};

export type GoalList = {
  created_at: string;
  id: number;
  title: string;
  updated_at: string;
};

export type WorkoutState = CommonState & {
  course?: Course;
  courseList: CourseList;
  courseListParams: CourseListParams;
};

export type CourseState = WorkoutState & {
  allCourses: Course[];
};

export type CourseType = {
  id: CourseTypes;
  title: string;
};

export enum LevelsID {
  beginner = 1,
  middle = 2,
  high = 3,
}

export interface ILevel {
  id: LevelsID;
  title: string;
}

export enum CourseProgressStatus {
  restarted = 1,
  inProgress = 2,
  completed = 3,
}

export const CourseProgressStatuses = {
  [CourseProgressStatus.restarted]: 'Перезапущен',
  [CourseProgressStatus.inProgress]: 'Начат',
  [CourseProgressStatus.completed]: 'Завершен',
} as const;
